import SignupValidationAPI from '../../APIs/SignupAPI/SignupValidationAPI'
import router from '../../../router/index'

export const resendMail = {
    state: {
        resendMailMsg: ''
    },
    actions: {
        resendMail({ commit }, sentInterval) {
            SignupValidationAPI.resendMail(sentInterval).then((res) => {
                if(res.status == 200) {
                    commit(
                        'RESEND_MAIL',
                        'Activation link has been resent, kindly check your email again. Check your spam folder if email not receive.'
                    )
                } else {
                    router.push('/404_NOT_FOUND')
                }
            })
        }
    },
    mutations: {
        RESEND_MAIL(state, resendMailMsg) {
            state.resendMailMsg = resendMailMsg
        }
    },
    getters: {
        resendMailMsg(state) {
            return state.resendMailMsg
        }
    }
}
